<template>
  <div>
    <!-- 中建八局个人总报告 ALL-->
    <pageOne :model="reportResult" :baseInfo="baseInfo" :info="info" :guid="guid" :privacyType="privacyType" />
    <pageTwo :model="reportResult" :PersonResult="PersonResult" :detailTuan="detailTuan" :isPerReport="isPerReport"
      :isBehaviorReport="isBehaviorReport" :isTeamReport="isTeamReport" :IsZero="IsZero" />

    <!-- 认知能力 -->
    <pageThree v-if="isBehaviorReport == true" :renzhi="renzhi" />
    <!-- 心理健康 -->
    <pageFour :xinli="xinli" v-if="xinli" :height="height" />
    <!-- 人格特质 -->
    <pageFive v-if="isPerReport == true" :model="PersonResult" />
    <!-- 团队适配 + 面试建议 -->
    <pageSix v-if="isTeamReport == true" :result="TeamScore" :model="data" :advice="msjy" :isPerReport="isPerReport"
      :IsTeamZero="IsTeamZero" :advice2="advice2" />
    <pageAdvice v-if="
        this.IsAdvice2 == true &&
        (isPerReport == true || isBehaviorReport == true)
      " :advice="advice3" :msjy="msjy" :adviceNoTeam="advice" :isTeamReport="isTeamReport" />
    <div v-if="!isPdf" v-loading.fullscreen.lock="fullscreenLoading"></div>
  </div>
</template>

<script>
import pageOne from "@/views/report/four/pageOne";
import pageTwo from "@/views/report/four/pageTwo";
import pageThree from "@/views/report/four/pageThree";
import pageFour from "@/views/report/four/pageFour";
import pageFive from "@/views/report/four/pageFive";
import pageSix from "@/views/report/four/pageSix";
import pageAdvice from "@/views/report/four/pageAdvice";
import { AllInfo } from "@/views/report/config/four";
import { AssessApi } from './config/apis.js'

export default {
  components: {
    pageOne,
    pageTwo,
    pageThree,
    pageFour,
    pageFive,
    pageSix,
    pageAdvice,
  },
  data() {
    return {
      data: AllInfo,
      info: [],
      reportResult: [], //心理+行为 等基础信息
      baseInfo: [], //候选人基础信息
      PersonResult: [], //人格报告信息
      detailTuan: [], //团队最高分 角色+ 解释
      renzhi: [], //认知能力 维度名+分数+定义
      xinli: [], //心理健康 信息
      TeamScore: [], //团队分数
      msjy: [], //认知模块面试建议
      advice: [], // 人格模块面试建议ALL
      advice2: [], // 人格模块面试建议
      advice3: [], // 人格模块面试建议
      guid: "",
      height: 756,
      interviewInfo: [], //人格的面试建议
      IsZero: false, //是否零分
      IsTeamZero: false,
      IsAdvice2: false, //建议
      isPerReport: false, //人格报告
      isTeamReport: false, //团队报告
      isPsychology: false, //心理报告
      isBehaviorReport: false, //认知报告
      searchUrl:
        "//report1014.acmcoder.com/api/test/reportAll?positionId=tixRnitiHytjtaMbnTIYGyC8GyxjGyE2&candId=tixRniKZtDnitDIZGaGbnTxiG1tjGyQa",
      teamUrl:
        "//kaosys.acmcoder.com/api/report/teamlity/6db440c9-303d-47af-8b2f-632a568d33af",
      personalityUrl:
        "//kaosys.acmcoder.com/api/report/candPersonalityNew/6db440c9-303d-47af-8b2f-632a568d33af",
      privacyType: 5,

      fullscreenLoading: true,
      isPdf: false,
    };
  },

  mounted() {
    let candId = this.getUrlParam("candId");
    let positionId = this.getUrlParam("positionId");
    this.loadApi(positionId, candId);
    if (location.hash.indexOf("pdf") > -1) {
      this.isPdf = true;
    }
  },
  methods: {
    loadApi(positionId, candId) {
      this.privacyType = 5;
      this.loadReportData(positionId, candId);
    },
    loadReportData(positionId, candId) {
      if (location.hash.indexOf("/allpdf") > -1) {
        this.searchUrl = AssessApi.reportAll + '?positionId=' + positionId + "&candId=" + candId; 
      }
      else { 
        this.searchUrl = AssessApi.reportAllEncryption + '?positionId=' + positionId + "&candId=" + candId;
      }

      $.get(this.searchUrl, (res) => {
        if (res.code != 0) {
          this.isBehaviorReport = false;
          if (res.code) {
            this.$alert(res.message || '面试报告超过有效期！', "提示", {
              showClose: false,
              showConfirmButton: false
            })
            return
          }
          return;
        }
        this.fullscreenLoading = false;
        if (
          location.hash.indexOf("/allpdf") > -1 ||
          location.hash.indexOf("/all") > -1
        ) {
          document.getElementById("demo").innerHTML =
            res.data.ent_name + "个人测评报告";
        }

        this.reportResult = res.data;

        if (this.reportResult.personalMustAns.degree != undefined) {
          this.info.push({
            name: "学历",
            value: this.reportResult.personalMustAns.degree,
          });
        }
        if (this.reportResult.personalMustAns.email != undefined) {
          this.info.push({
            name: "邮箱",
            value: this.reportResult.personalMustAns.email,
          });
        }
        if (this.reportResult.personalMustAns.mobile != undefined) {
          this.info.push({
            name: "电话",
            value: this.reportResult.personalMustAns.mobile,
          });
        }
        if (this.reportResult.personalMustAns.university != undefined) {
          this.info.push({
            name: "学校",
            value: this.reportResult.personalMustAns.university,
          });
        }
        if (this.reportResult.personalMustAns.major != undefined) {
          this.info.push({
            name: "专业",
            value: this.reportResult.personalMustAns.major,
          });
        }

        this.info = this.info.slice(0, 4);

        this.loadPaperType(res);
        this.baseInfo = res.data.personalMustAns;
        this.renzhi = res.data.renzhi;
        if (this.renzhi) {
          this.renzhi.map((item) => {
            if (item.score == 0) {
              item.score = 0.12;
            }
          });
        }
        let count = 0;

        this.xinli = res.data.xinli;
        // this.xinli = this.data.heartTable;
        if (this.xinli) {
          this.xinli.map((item, index) => {
            item.level2.map((ll) => {
              count++;
            });
          });
          if (count == 1) {
            this.height = 100;
          }
          if (count == 2) {
            this.height = 100;
          }
          if (count == 3) {
            this.height = 220;
          }
          if (count == 4) {
            this.height = 320;
          }
          if (count == 5) {
            this.height = 248;
          }
          if (count == 6) {
            this.height = 350;
          }
          if (count == 7) {
            this.height = 350;
          }
          if (count == 8) {
            this.height = 370;
          }
          if (count == 9) {
            this.height = 390;
          }
          if (count == 10) {
            this.height = 500;
          }
          if (count == 11) {
            this.height = 500;
          }
          if (count == 12) {
            this.height = 600;
          }
          if (count == 13) {
            this.height = 620;
          }
          if (count == 14) {
            this.height = 630;
          }
          if (count == 15) {
            this.height = 720;
          }
          if (count == 16) {
            this.height = 740;
          }
          if (count == 17) {
            this.height = 757;
          }
        }

        // if (this.xinli.length == 1) {
        //   this.height = 100;
        // }
        // if (this.xinli.length == 2) {
        //   this.height = 248;
        // }
        // if (this.xinli.length == 3) {
        //   this.height = 390;
        // }
        // if (this.xinli.length == 4) {
        //   this.height = 500;
        // }
        // if (this.xinli.length == 5) {
        //   this.height = 630;
        // }
        // if (this.xinli.length == 6) {
        //   this.height = 757;
        // }

        // console.log(count);

        if (this.xinli) {

          //一级维度分数转换
          this.xinli.map((item) => {
            if (
              (item.score > 3.33 || item.score == 3.33) &&
              (item.score < 3.83 || item.score == 3.83)
            ) {
              item.score = 1;
            } else if (
              (item.score > 3.84 || item.score == 3.84) &&
              (item.score < 4.25 || item.score == 4.25)
            ) {
              item.score = 2;
            } else if (
              (item.score > 4.26 || item.score == 4.26) &&
              (item.score < 4.99 || item.score == 4.99)
            ) {
              item.score = 3;
            } else if (
              (item.score > 5 || item.score == 5) &&
              (item.score < 6 || item.score == 6)
            ) {
              item.score = 4;
            } else if (
              (item.score > 6.01 || item.score == 6.01) &&
              (item.score < 6.61 || item.score == 6.61)
            ) {
              item.score = 5;
            } else if (
              (item.score > 6.62 || item.score == 6.62) &&
              (item.score < 7.24 || item.score == 7.24)
            ) {
              item.score = 6;
            } else if (
              (item.score > 7.25 || item.score == 7.25) &&
              (item.score < 8.32 || item.score == 8.32)
            ) {
              item.score = 7;
            } else if (
              (item.score > 8.33 || item.score == 8.33) &&
              (item.score < 9.07 || item.score == 9.07)
            ) {
              item.score = 8;
            } else if (
              (item.score > 9.08 || item.score == 9.08) &&
              (item.score < 9.49 || item.score == 9.49)
            ) {
              item.score = 9;
            } else if (
              (item.score > 9.5 || item.score == 9.5) &&
              (item.score < 10 || item.score == 10)
            ) {
              item.score = 10;
            }
          });

          //二级维度分数转换
          this.xinli.map((item) => {
            item.level2.map((ll) => {
              if (
                (ll.score > 3.33 || ll.score == 3.33) &&
                (ll.score < 3.83 || ll.score == 3.83)
              ) {
                ll.score = 1;
              } else if (
                (ll.score > 3.84 || ll.score == 3.84) &&
                (ll.score < 4.25 || ll.score == 4.25)
              ) {
                item.score = 2;
              } else if (
                (ll.score > 4.26 || ll.score == 4.26) &&
                (ll.score < 4.99 || ll.score == 4.99)
              ) {
                ll.score = 3;
              } else if (
                (ll.score > 5 || ll.score == 5) &&
                (ll.score < 6 || ll.score == 6)
              ) {
                ll.score = 4;
              } else if (
                (ll.score > 6.01 || ll.score == 6.01) &&
                (ll.score < 6.61 || ll.score == 6.61)
              ) {
                ll.score = 5;
              } else if (
                (ll.score > 6.62 || ll.score == 6.62) &&
                (ll.score < 7.24 || ll.score == 7.24)
              ) {
                ll.score = 6;
              } else if (
                (ll.score > 7.25 || ll.score == 7.25) &&
                (ll.score < 8.32 || ll.score == 8.32)
              ) {
                ll.score = 7;
              } else if (
                (ll.score > 8.33 || ll.score == 8.33) &&
                (ll.score < 9.07 || ll.score == 9.07)
              ) {
                ll.score = 8;
              } else if (
                (ll.score > 9.08 || ll.score == 9.08) &&
                (ll.score < 9.49 || ll.score == 9.49)
              ) {
                ll.score = 9;
              } else if (
                (ll.score > 9.5 || ll.score == 9.5) &&
                (ll.score < 10 || ll.score == 10)
              ) {
                ll.score = 10;
              }
            });
          });

          this.xinli.map((item) => {
            if (item.score == 0) {
              item.score = 0.12;
            }
          });

          this.xinli.map((item) => {
            item.level2.map((ll) => {
              if (ll.score == 0) {
                ll.score = 0.12;
              }
            });
          });
        }

        // this.xinli = this.data.heartTable;
        this.msjy = res.data.msjy;
      });
    },

    loadPaperType(res) {
      if (res.data.paper_type.indexOf("3") > -1) {
        this.isPerReport = true;
      }
      if (res.data.paper_type.indexOf("4") > -1) {
        this.isTeamReport = true;
      }
      if (res.data.paper_type.indexOf("5") > -1) {
        this.isBehaviorReport = true;
      }
      this.guid = res.data.guid; //获取团队/人格 的guid
      if (res.data.guid) {
        this.personalityUrl = AssessApi.candPersonalityNew + '/' + res.data.guid;
        this.teamUrl = AssessApi.team + '/' + res.data.guid;
        this.loadPersonalityData();
        this.loadTeamData();
      }
    },
    //人格
    loadPersonalityData() {
      $.get(this.personalityUrl, (res) => {
        if (res.errno != 0) {
          this.isPerReport = false;
          return;
        }
        this.interviewInfo = res.interviewInfo;
        if (this.interviewInfo.fucongxing) {
          this.advice.push({
            name: "服从性",
            define: this.interviewInfo.fucongxing,
          });
        }

        if (this.interviewInfo.gongzuotiaozhengnengli) {
          this.advice.push({
            name: "工作调整能力",
            define: this.interviewInfo.gongzuotiaozhengnengli,
          });
        }
        if (this.interviewInfo.lingdaonengil) {
          this.advice.push({
            name: "领导能力",
            define: this.interviewInfo.lingdaonengil,
          });
        }

        if (this.interviewInfo.qingxuwending) {
          this.advice.push({
            name: "情绪稳定",
            define: this.interviewInfo.qingxuwending,
          });
        }

        if (this.interviewInfo.shejiaonengli) {
          this.advice.push({
            name: "社交能力",
            define: this.interviewInfo.shejiaonengli,
          });
        }

        if (this.interviewInfo.shenghuobudiao) {
          this.advice.push({
            name: "生活步调",
            define: this.interviewInfo.shenghuobudiao,
          });
        }

        if (this.interviewInfo.shuchujingli) {
          this.advice.push({
            name: "输出精力",
            define: this.interviewInfo.shuchujingli,
          });
        }

        //判断建议分页
        if (this.advice.length > 2 && this.msjy) {
          this.IsAdvice2 = true;
          this.advice2 = this.advice.slice(0, 2);
          this.advice3 = this.advice.slice(2);
        } else if (this.advice.length > 3 && !this.msjy) {
          this.IsAdvice2 = true;
          this.advice2 = this.advice.slice(0, 3);
          this.advice3 = this.advice.slice(3);
        } else {
          this.advice2 = this.advice;
        }

        if (
          res.personalityValues.A +
            res.personalityValues.B +
            res.personalityValues.C +
            res.personalityValues.D +
            res.personalityValues.E +
            res.personalityValues.F +
            res.personalityValues.G +
            res.personalityValues.H +
            res.personalityValues.I +
            res.personalityValues.J +
            res.personalityValues.a +
            res.personalityValues.b +
            res.personalityValues.c +
            res.personalityValues.d +
            res.personalityValues.e +
            res.personalityValues.f +
            res.personalityValues.g +
            res.personalityValues.h +
            res.personalityValues.i +
            res.personalityValues.j ==
          0
        ) {
          this.IsZero = true;
        }

        // 零分赋值
        // if (
        //   (res.personalityValues.h +
        //     res.personalityValues.i +
        //     res.personalityValues.j) /
        //     3 ==
        //   0
        // ) {
        //   res.personalityValues.h = 0.5;
        // }

        // if (
        //   (res.personalityValues.G +
        //     res.personalityValues.H +
        //     res.personalityValues.I) /
        //     3 ==
        //   0
        // ) {
        //   res.personalityValues.H = 0.5;
        // }

        // if (
        //   res.personalityValues.B +
        //     res.personalityValues.c +
        //     res.personalityValues.C ==
        //   0
        // ) {
        //   res.personalityValues.B = 0.5;
        // }

        // if (
        //   res.personalityValues.I +
        //     res.personalityValues.J +
        //     res.personalityValues.g ==
        //   0
        // ) {
        //   res.personalityValues.I = 0.5;
        // }

        // if (
        //   res.personalityValues.d +
        //     res.personalityValues.F +
        //     res.personalityValues.f +
        //     res.personalityValues.e ==
        //   0
        // ) {
        //   res.personalityValues.d = 0.6;
        // }

        // if (res.personalityValues.D + res.personalityValues.E == 0) {
        //   res.personalityValues.D = (1 * 1) / 3;
        // }

        // if (
        //   res.personalityValues.a +
        //     res.personalityValues.A +
        //     res.personalityValues.b ==
        //   0
        // ) {
        //   res.personalityValues.a = 0.5;
        // }

        //人格信息 拼json  维度名称 + 分数 + 解释
        this.PersonResult.push(
          //批判性 + 崇拜性 + 受役性
          {
            name: "服从性",
            score:
              (res.personalityValues.h +
                res.personalityValues.i +
                res.personalityValues.j) /
              3,
            content: res.obedience,
          },
          //思考性、细致性、条理性

          {
            name: "工作调整能力",
            score:
              (res.personalityValues.G +
                res.personalityValues.H +
                res.personalityValues.I) /
              3,
            content: res.ability2AdjustWork,
          },

          //领导性、统御需求、冒险性
          {
            name: "领导能力",
            score:
              (res.personalityValues.B +
                res.personalityValues.c +
                res.personalityValues.C) /
              3,
            content: res.leadership,
          },

          //喜新性、稳定性
          {
            name: "情绪稳定",
            score: (res.personalityValues.J + res.personalityValues.g) / 2,
            content: res.emotionalStability,
          },

          //社交性、表现欲、合群性、亲和需求

          {
            name: "社交能力",
            score:
              (res.personalityValues.d +
                res.personalityValues.F +
                res.personalityValues.f +
                res.personalityValues.e) /
              4,
            content: res.sociability,
          },

          //迅速性、活动性
          {
            name: "生活步调",
            score: (res.personalityValues.D + res.personalityValues.E) / 2,
            content: res.paceOfLife,
          },
          //投注性、意志力、成就需求
          {
            name: "输出精力",
            score:
              (res.personalityValues.a +
                res.personalityValues.A +
                res.personalityValues.b) /
              3,
            content: res.outputEnergy,
          }
        );
      });
    },
    loadTeamData() {
      $.get(this.teamUrl, (res) => {
        if (res.errno != 0) {
          this.isTeamReport = false;
          return;
        }
        this.TeamScore = res.candPapers;

        var s = 0;
        for (var i = this.TeamScore.length - 1; i >= 0; i--) {
          s += this.TeamScore[i];
        }
        if (s == 0) {
          this.IsTeamZero = true;
        }

        res.mapResult.list.map((item) => {
          if (item.isMax == true) {
            this.detailTuan.push({
              name: item.roleText.name,
              define: item.roleText.maxTip,
            });
          }
        });
      });
    },

    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 800px;
  height: auto;
  margin: 0px auto;
  background-color: white;
  .pdt-btn {
    position: fixed;
    right: 20px;
    top: 220px;
    .download {
      padding: 40px 20px;
      background: #333;
      color: #fff;
      display: block;
      margin-bottom: 15px;
    }
    .download1 {
      padding: 40px 12px;
      background: #333;
      color: #fff;
      display: block;
      margin-bottom: 15px;
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/views/report/four.vue